export default __webpack_public_path__ + "static/media/farm.52c5c7ce.jpg";